import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  fetchHomepageIfNeeded, fetchTopicsIfNeeded, fetchTopicsCountIfNeeded, logout, getSearchData, setSelectedSidebarNav, fetchFiltersIfNeeded
} from '../../actions'
import SidebarComponent from '../../components/sidebar/SidebarComponent'

import LibraryComponent from '../../components/library/LibraryComponent'
import TopicHelpers from '../../classes/TopicHelpers'
import Profile from '../../classes/profile'
import * as TLM from '../../constants/tlm'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import { ENTITY, LIBRARY_MODULE, VIDEO } from '../../constants/commons'
import GoogleAnalytics from '../../classes/GoogleAnalytics'

class LibraryContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    homepage: PropTypes.object,
    topic: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    fetchHomepage: PropTypes.func.isRequired,
    fetchTopics: PropTypes.func.isRequired,
    fetchTopicsCount: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    error: PropTypes.object,
    topics: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      subType: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      thumbnail: PropTypes.string,
      topicIdLeft: PropTypes.string,
      topicIdRight: PropTypes.string
    })),
    topicsCount: PropTypes.number,
    page: PropTypes.number,
    size: PropTypes.number,
    totalSize: PropTypes.number,
    fetchTopicsPage: PropTypes.func,
    entityTypes: PropTypes.arrayOf(PropTypes.string),
    networkLabels: PropTypes.arrayOf(PropTypes.string),
    categorys: PropTypes.arrayOf(PropTypes.string),
    getSearchData: PropTypes.func,
    searchResults: PropTypes.array,
    fetchFiltersIfNeeded: PropTypes.func,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      page: 0,
      rowsPerPage: 10,
      typeSearch: null,
      nwSearch: null,
      cgSearch: null,
      nameSearch: null,
      order: 'asc'
    }
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(LIBRARY_MODULE, this.props.location, this.props.profile)
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
    this.props.fetchTopics(this.state.page, this.state.rowsPerPage, this.state.typeSearch, this.state.nwSearch, this.state.cgSearch, this.state.nameSearch, this.state.asc)
    this.props.fetchTopicsCount(this.state.page, this.state.rowsPerPage, this.state.typeSearch, this.state.nwSearch, this.state.cgSearch, this.state.nameSearch, this.state.asc)
    this.props.fetchFiltersIfNeeded()
  }

  fetchTopicsPage (page, size, typeSearch, nwSearch, cgSearch, nameSearch, order) {
    this.setState({page: page, size: size, typeSearch: typeSearch, nwSearch: nwSearch, cgSearch: cgSearch, nameSearch: nameSearch, order: order});
    this.props.fetchTopics(page, size, typeSearch, nwSearch, cgSearch, nameSearch, order)
    if (page === 0) {
      this.props.fetchTopicsCount(page, size, typeSearch, nwSearch, cgSearch, nameSearch, order)
    }
  }

  render () {
    const {profile, topic, location, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
    const _fetchTopics = this.fetchTopicsPage.bind(this)


    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          topic={topic}
          logout={myLogout}
          location={location}
          homepage={homepage ? homepage : this.props.homepage}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
          />
        <LibraryComponent
          isFetching={this.props.isFetching}
          topics={this.props.topics}
          topicsCount={this.props.topicsCount}
          error={this.props.error}
          page={this.props.page}
          size={this.props.size}
          totalSize={this.props.totalSize}
          fetchTopicsWithPage={_fetchTopics}
          entityTypes={this.props.entityTypes}
          networkLabels={this.props.networkLabels}
          categorys={this.props.categorys}
          getSearchData={this.props.getSearchData}
          searchResults={this.props.searchResults}
          />
      </>
    )
  }
}

function mapStateToProps (state) {
  const isAdmin = state.user.isAdmin
  const profile = state.user.profile && new Profile(state.user.profile)
  const homepage = state.homepage.list
  const selectedNav = state.sidebar.selectedNav
  const isContentIntelligence = state.sidebar.isContentIntelligence
  const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
  const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
  const isAIInsights = state.sidebar.isAIInsights
  const topic = state.topics.byId
  const topicsList = state.topics.list
  const comparisonsList = state.compare.list
  const filters = state.libraryFilter.details
  const topicsCount = (state.topics.count && state.topics.count.details) && state.topics.count.details.total_size
  const isFetching = (topicsList && topicsList.isFetching) || topicsList.didInvalidate || !topicsList.details || !filters || (filters && filters.isFetching)
  const searchResultLists = state.searchByKeword.details?state.searchByKeword.details:[]
  let searchResults = null
  if (searchResultLists) {
    searchResults = searchResultLists.map(searchResult => {
      return {
        id: searchResult.id,
        type: (searchResult.is_entity ? ENTITY : VIDEO ),
        subType: searchResult.entity_type || TLM.CHANNEL,
        name: searchResult.display_name || searchResult.name,
        searchName: searchResult.name,
        thumbnail: searchResult.entity_override_image? searchResult.entity_override_image : searchResult.thumbnail,
        metadata: TopicHelpers.getCategory(searchResult),
        networkLabel: TopicHelpers.getNetworkLabel(searchResult.labels)
      }
    })
  }
  const error = topicsList.error || comparisonsList.error
  let topics = null
  let page = 0
  let size = 0
  let totalSize = 0
  let entityTypes = null
  let networkLabels = null
  let categorys = null
  if (topicsList.details) {
    topics = topicsList.details.topics.map(topic => {
      return {
        id: topic.id,
        type: (topic.is_entity ? ENTITY : VIDEO ),
        subType: topic.entity_type || TLM.CHANNEL,
        name: topic.display_name || topic.name,
        searchName: topic.name,
        thumbnail: topic.entity_override_image? topic.entity_override_image : topic.thumbnail,
        metadata: TopicHelpers.getCategory(topic),
        networkLabel: TopicHelpers.getNetworkLabel(topic.labels),
        entityLocalizationOverride: topic.entity_localization_override
      }
    })
    if (filters) {
      entityTypes = filters.entity_types
      networkLabels = filters.network_labels
      categorys = filters.categorys
    }
    page = topicsList.details.page_number
    size = topicsList.details.size
    totalSize = topicsCount
  }

  return {
    isAdmin,
    profile,
    homepage,
    topic,
    topicsCount,
    isFetching,
    error,
    topics,
    page,
    size,
    totalSize,
    entityTypes,
    networkLabels,
    categorys,
    searchResults,
    selectedNav,
    isContentIntelligence,
    isCatalogAnalysis,
    isPerformanceAnalysis,
    isAIInsights
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
    fetchTopics: (page, size, typeSearch, nwSearch, cgSearch, nameSearch, order) => dispatch(fetchTopicsIfNeeded(page, size, typeSearch, nwSearch, cgSearch, nameSearch, order)),
    fetchTopicsCount: (page, size, typeSearch, nwSearch, cgSearch, nameSearch, order) => dispatch(fetchTopicsCountIfNeeded(page, size, typeSearch, nwSearch, cgSearch, nameSearch, order)),
    getSearchData: (val) => dispatch(getSearchData(val)),
    fetchFiltersIfNeeded: () => dispatch(fetchFiltersIfNeeded()),
    selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
    logout: () => dispatch(logout())
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(LibraryContainer)
